import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { translate } from '@/i18n/translate'

export const loginSchema = z.object({
  email: z.string().email(translate('common.validations.invalidEmail')),
  password: z.string().min(8, translate('common.validations.invalidPassword')),
})
export type LoginSchema = z.infer<typeof loginSchema>

export type LoginSchemaMethods = UseFormReturn<LoginSchema>
export type LoginSchemaFields = keyof LoginSchema
